import { FC } from 'react';
import { BulletIcons } from '@/assets';

import styles from './NumbersProgress.module.scss';

type Props = {
  length: number;
  isVisible: boolean;
  activeItem: number;
  onClick: (_index: number) => void;
};

export const NumbersProgress: FC<Props> = ({
  length,
  isVisible,
  activeItem,
  onClick,
}) => {
  const numbers = Array.from({ length });
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <div className={`${styles.numbers} ${isVisibleStyles}`}>
      {numbers.map((_title, index) => (
        <div key={index} className={styles.number_item}>
          <button
            type="button"
            className={`${styles.number_button} ${activeItem >= index ? styles.isActive : styles.isHidden}`}
            onClick={() => onClick(index)}
          >
            <span>0{index + 1}</span>
            <div className={styles.icons_wrapper}>
              <BulletIcons icon="circle transparent" />
              <BulletIcons icon="circle dark" />
            </div>
          </button>
        </div>
      ))}
      <div className={styles.line_wrapper}>
        <span className={styles.line} />
        <span
          className={styles.progress}
          style={{ width: `${(100 / (numbers.length - 1)) * activeItem}%` }}
        />
      </div>
    </div>
  );
};
